<div [class.disabled]="form.disabled" class="h-100 d-flex flex-column overflow-hidden">
    <div class="overflow-hidden flex-grow-1">
        <p-editor
            placeholder="(选填)留言..."
            [formControl]="form.controls.body"
            [disabled]="form.controls.body.disabled"
        />
    </div>
</div>
